// src/services/AppShell.jsx
import { HashRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { lazy, Suspense } from "react";               // ← NUEVO
import App from "../App";
import Dashboard from "../pages/Dashboard";                             
import SocioPanel from "../pages/SocioPanel";
import Login from "../components/Login";
import { getToken, isEmpleado, isSocio, isGestorFiscal, getSocioId } from "./auth";
import PreviewDoc from "../pages/PreviewDoc";
import AltaWizard from "../pages/AltaWizard";

// ← NUEVO: módulo lazy
const FacturacionAppLazy = lazy(() => import("../modules/facturacion/FacturacionApp"));

// Guarda "next" y redirige a /login si no hay token
function RequireAuth({ children }) {
  const token = getToken();
  if (!token) {
    try {
      const next = window.location.hash || "#/";
      sessionStorage.setItem("asotrans_next_path", next);
    } catch { /* noop */ }
    return <Navigate to="/login" replace />;
  }
  return children;
}

// Solo empleados (si no lo es, lo mando a home)
function RequireEmpleado({ children }) {
  if (!isEmpleado()) return <Navigate to="/" replace />;
  return children;
}

// Decide qué mostrar en "/" y "/socios"
function DashboardGate() {
  if (isEmpleado() || isGestorFiscal()) return <Dashboard />;
  if (isSocio()) {
    const id = getSocioId();
    if (id) return <Navigate to={`/socios/${id}`} replace />;
  }
  return <Navigate to="/login" replace />;
}

function HomeGate() {
  if (isEmpleado()) return <App />;
  if (isSocio()) {
    const id = getSocioId();
    if (id) return <Navigate to={`/socios/${id}`} replace />;
  }
  return <Navigate to="/login" replace />;
}

// Controla acceso a /socios/:id
function SocioRoute() {
  const { id } = useParams();
  if (isEmpleado()) {
    return (
      <SocioPanel
        role="empleado"
        onBack={() => (window.location.hash = "#/socios")}
        onOpenDocuments={() => {}}
      />
    );
  }
  if (isSocio()) {
    const myId = getSocioId();
    if (!myId) return <Navigate to="/login" replace />;
    if (String(myId) !== String(id)) {
      return <Navigate to={`/socios/${myId}`} replace />;
    }
    return <SocioPanel role="socio" onOpenDocuments={() => {}} />;
  }
  return <Navigate to="/login" replace />;
}

export default function AppShell() {
  return (
    <Router>
      <Routes>
        {/* Público */}
        <Route path="/login" element={<Login />} />

        {/* Privado */}
        <Route
          path="/"
          element={
            <RequireAuth>
              <DashboardGate />
            </RequireAuth>
          }
        />
        <Route
          path="/socios"
          element={
            <RequireAuth>
              <HomeGate />
            </RequireAuth>
          }
        />
        <Route
          path="/socios/:id"
          element={
            <RequireAuth>
              <SocioRoute />
            </RequireAuth>
          }
        />

        {/* Preview doc */}
        <Route
          path="/preview/:id"
          element={
            <RequireAuth>
              <PreviewDoc />
            </RequireAuth>
          }
        />

        {/* Wizard de Alta (solo empleados) */}
        <Route
          path="/alta/wizard"
          element={
            <RequireAuth>
              <RequireEmpleado>
                <AltaWizard />
              </RequireEmpleado>
            </RequireAuth>
          }
        />

        {/* === NUEVO: módulo de Facturación (lazy, aislado y solo empleados) === */}
        <Route
          path="/facturacion/*"
          element={
            <RequireAuth>
              <RequireEmpleado>
                <Suspense fallback={<div className="p-6">Cargando facturación…</div>}>
                  <FacturacionAppLazy />
                </Suspense>
              </RequireEmpleado>
            </RequireAuth>
          }
        />

        {/* catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
